export const tachographState = {
  name: 'tachographState',
  url: '/avto/tachographs',
  component: 'tachographs',
  resolve: {},
  data: {
    title: 'Тахографы',
  },
}
